export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "exam_types": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage exam types"])},
        "new_exam_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New exam type"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are no exam types to show"])}
      },
      "fr": {
        "exam_types": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérer les types d’examens"])},
        "new_exam_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau type d’examen"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    }
  })
}